module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_04 (1).6a33d44e.png";